import { EntityType, getDefaultAddressSchemeTypeByCountry } from '@components'

import { useMemo } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { DEFAULT_INVOICE_LANGUAGE } from '../../../../invoices/constants/defaultInvoiceLanguage'
import { invoiceLanguageToLocale } from '../../../../invoices/constants/invoiceLanguageToLocale'
import { InvoiceDocumentType } from '../../../../invoices/enums/invoiceDocumentType'
import { getDefaultInvoiceLocale } from '../../../../invoices/utils/getDefaultInvoiceLocale'
import { useGetZervantDocumentSettings } from '../../../../invoicingSettings/hooks/useGetZervantDocumentSettings'
import type { PredefinedCustomerValues } from '../types/customerForm/predefinedCustomerValues'

export const usePredefinedCustomerFormValues = () => {
  const { organization, isLoading: isLoadingOrganization } = useUserOrganization()
  const { getDefaultSettingsValue, isLoading: isLoadingInvoiceSettings } = useGetZervantDocumentSettings(
    InvoiceDocumentType.Invoice,
  )

  const isLoading = isLoadingOrganization || isLoadingInvoiceSettings
  const countryId = organization?.countryId
  const invoiceSettingsLanguage = getDefaultSettingsValue('language')
  // Unlike the invoice editor, a new customer always needs a resolved language (there's no
  // later default-values step to fall back to DEFAULT_INVOICE_LANGUAGE), so fall back here.
  const language = getDefaultInvoiceLocale(invoiceSettingsLanguage) ?? invoiceLanguageToLocale[DEFAULT_INVOICE_LANGUAGE]

  const predefinedCustomerValues: PredefinedCustomerValues = useMemo(
    () => ({
      address: {
        country: countryId,
      },
      eInvoiceAddress: {
        scheme: getDefaultAddressSchemeTypeByCountry(false, countryId),
      },
      entityType: EntityType.Private,
      language,
      shippingAddress: {
        country: countryId,
      },
    }),
    [countryId, language],
  )

  return { predefinedCustomerValues, isLoading }
}
